export interface PlanModel {
  id: number
  name: string
  displayName: string
}

export type PlanListModel = PlanModel[]

export namespace Plan {
  export class Enum {
    static readonly STARTER = new Enum(1, 'Starter', 'info-900', 'info-100')
    static readonly SILVER = new Enum(2, 'Silver', 'grey-900', 'grey-100')
    static readonly GOLD = new Enum(3, 'Gold', 'warning-900', 'warning-200')
    static readonly BLACK = new Enum(5, 'Black', 'common-white', 'primary-950')

    private constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly color: string,
      public readonly backgroundColor: string
    ) {}
  }

  export const findById = (id: number | null): Plan.Enum | undefined => {
    if (!id) return undefined
    return Object.values(Plan.Enum).find(p => p.id === id)
  }

  export const getByName = (name: string | null): Plan.Enum | undefined => {
    if (!name) return undefined
    return Object.values(Plan.Enum).find(plan => plan.name === name)
  }

  export const getAll = (): Plan.Enum[] => {
    return Object.values(Plan.Enum)
  }

  export const getNames = () => {
    return getAll().reduce((agg, p) => ({ ...agg, [p.name.toLowerCase()]: p.id }), {})
  }
}
